<template>
  <ab-flow-base-cmp :movable="true" :block="block" class="navigate-to-editor-cmp">
    <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>
    <q-card>

      <q-card-section class="bg-yellow-8 text-black">
        Navigate to: {{route}}
      </q-card-section>

    </q-card>

    <div class="results">
      <ab-flow-link-connector class="q-mt-sm" :block="block" type="output" event="navigated"/>
    </div>

  </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";
import {renderMixins} from "@/components/DiagramDesigner/Editor/components/renderMixins";

export default {
  mixins: [renderMixins],
  components: { AbFlowBaseCmp, AbFlowLinkConnector},
  inject: ['canvas'],
  props: ['block'],
  name: "NavigateEditorCmp",
  computed: {

    /**
     * Return name
     * @return {{}}
     */
    route() {
      return this.interpretString(this.block.properties?.route) || "n/a"
    },
  }
}

</script>

<style lang="scss">

.navigate-to-editor-cmp {
  .ev-run {
    left:-12px;
    position: absolute;
    top:calc(50% - 5px);
  }

  .results {
    position: absolute;
    right: -12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

</style>
